export default __webpack_public_path__ + "static/media/personality_INFj.5d2c36f0.png";